import { useMemo } from 'react';
import { getInsuranceHeadlineCopy } from '../../../../../../Account/Profile/Insurance/util/insuranceDetails';

export default (detailsResult: any) => {
  return useMemo(() => {
    return getInsuranceHeadlineCopy(detailsResult);
  }, [detailsResult]);
};
